import { useEventListener } from 'usehooks-ts';

export default function useRotateResize(callback?: VoidFunction) {
  useEventListener('orientationchange', () => {
    window.dispatchEvent(new Event('resize'));
    callback?.();
  });
}
